import { createSelector } from 'reselect';
import { filter, find } from 'lodash';
import { campaignStatuses } from '../../constants';
import { createSecretKey } from 'crypto';

export const getCampaigns = state => state.firestore.ordered.campaigns;

export const getCampaignsCount = createSelector(
  [getCampaigns],
  camapignList => {
    return camapignList ? camapignList.length : 0;
  }
);

export const getAllCampaigns = createSelector(
  [getCampaigns],
  camapignList => {
    return camapignList;
  }
);

export const getCampaignsLoaded = createSelector(
  [getCampaigns],
  camapignList => {
    return camapignList !== undefined;
  }
);

export const getActiveCampaigns = createSelector(
  [getCampaigns],
  camapignList => {
    return filter(
      camapignList,
      camp => camp.status === campaignStatuses.ACTIVE
    );
  }
);

export const getCamapaignById = (state, campaignId) => {
  return find(
    state.firestore.ordered.campaigns,
    camp => camp.id === campaignId
  );
};



// WEBPACK FOOTER //
// ./src/store/selectors/campaigns.js